/**
 * Vocabulário dos tons.
 *
 * A regra "nunca comunicar estado só por cor" só se cumpre se cada tom tiver
 * sempre uma PALAVRA e um ÍCONE associados. Ficam aqui, num lugar só, para não
 * haver um componente a dizer "Aviso" e outro "Atenção".
 */

export type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';
export type BannerTone = 'info' | 'success' | 'warning' | 'danger';

/** Palavra que acompanha a cor. Lida em voz alta pelo leitor de tela. */
export const TONE_WORD: Record<Tone, string> = {
  neutral: 'Informação',
  info: 'Informação',
  success: 'Tudo certo',
  warning: 'Atenção',
  danger: 'Erro',
};

/** Ícone por omissão de cada tom. Texto simples: zero pedidos de rede. */
export const TONE_ICON: Record<Tone, string> = {
  neutral: 'ℹ️',
  info: 'ℹ️',
  success: '✅',
  warning: '⚠️',
  danger: '⛔',
};

/** Junta classes ignorando falsos. Evita uma dependência só para isto. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
